<template>
  <v-dialog v-model="open" scrollable width="700">
    <v-form v-model="valid" v-if="amenity" @submit.prevent="save()">
      <v-card>
        <v-card-title class="primary white--text">
          <span v-if="mode === 'create'">Ausstattung erfassen</span>
          <span v-if="mode === 'edit'">Ausstattung bearbeiten</span>
        </v-card-title>
        <v-card-text class="mt-3">
          <v-row>
            <v-col>
              <v-text-field
                outlined
                dense
                v-model="amenity.name"
                label="Name"
                type="text"
                :maxlength="255"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" text @click="abort()">Abbrechen</v-btn>
          <v-btn color="primary" text type="submit" :disabled="!valid"
            >Speichern
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  data: () => ({
    open: false,
    mode: "create",
    valid: false,

    amenityId: null,
    amenity: null,

    textRules: [v => !!v || "Muss ausgefüllt sein"],
    emailRules: [
      v => (!!v && /.+@.+\..+/.test(v)) || "E-Mail muss gültig sein"
    ],
    numericRules: [v => parseInt(v) > 0 || "Muss eine Nummer > 0 sein"]
  }),

  watch: {
    open(value) {
      if (value) {
        if (this.mode === "create") {
          this.resetForm();
        } else if (this.mode === "edit") {
          this.fetchAmenity();
        }
      }
    }
  },

  computed: {
    ...mapState("app", ["configs"]),

    genders() {
      return Object.keys(this.configs.genders).map(gender => ({
        text: this.configs.genders[gender],
        value: gender
      }));
    }
  },

  methods: {
    /**
     * Reset form.
     */
    resetForm() {
      this.amenity = {
        id: null,
        name: null
      };
    },

    /**
     * Fetch amenity from server
     */
    fetchAmenity() {
      this.$api.http
        .get(`backoffice/amenities/${this.amenityId}`)
        .then(response => {
          this.amenity = response.data;
        });
    },

    /**
     * Close modal
     */
    abort() {
      this.open = false;
    },

    /**
     * Save amenity.
     */
    save() {
      if (this.mode === "create") {
        this.$api.http
          .post(`backoffice/amenities`, this.amenity)
          .then(response => {
            this.open = false;
            this.$emit("saved");
          })
          .catch(error => {
            const message = error.response.data.message;
            this.$toast.error(message);
          });
      } else if (this.mode === "edit") {
        this.$api.http
          .put(`backoffice/amenities/${this.amenityId}`, this.amenity)
          .then(response => {
            this.open = false;
            this.$emit("saved");
          })
          .catch(error => {
            const message = error.response.data.message;
            this.$toast.error(message);
          });
      }
    }
  }
};
</script>
